import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import metadata from './WMICWaterMitigationDetails.metadata.json5';
import './WMICWaterMitigationDetails.messages';

function WMICWaterMitigationDetails({ id, riskView, readOnly, onRiskViewChange, onValidate }) {
    const { refreshData } = useDataRefresh();
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }

        return () => {
            if (onValidate) {
                onValidate(true, id);
            }
        };
    }, [isComponentValid, onValidate, id]);

    const updateRiskView = useCallback(
        newData => {
            refreshData();
            onRiskViewChange(newData);
        },
        [onRiskViewChange, refreshData]
    );

    const overrideProps = {
        '@field': {
            parentNode: riskView?.rating?.waterMitigation,
            readOnly,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={riskView?.rating?.waterMitigation}
            overrideProps={overrideProps}
            onModelChange={updateRiskView}
            onValidationChange={setComponentValidation}
        />
    );
}

WMICWaterMitigationDetails.propTypes = {
    riskView: PropTypes.shape({
        rating: PropTypes.shape({
            waterMitigation: PropTypes.object.isRequired,
        }).isRequired,
    }).isRequired,
    readOnly: PropTypes.bool.isRequired,
    onRiskViewChange: PropTypes.func.isRequired,
};

export default WMICWaterMitigationDetails;
